function findTask(tasks, taskId) {
    return tasks.find((task) => task?._id === taskId);
}

function syncExistingTask(tasks = [], task = {}, operation = "modified") {
    if (!Array.isArray(tasks) || !task?._id) return false;

    if (task.isParentTask === false && task.ParentTaskId) {
        const parent = findTask(tasks, task.ParentTaskId);
        if (!parent || !Array.isArray(parent.subtaskArray)) return false;

        const childIndex = parent.subtaskArray.findIndex((child) => child?._id === task._id);
        if (operation === "removed") {
            if (childIndex === -1) return false;
            parent.subtaskArray.splice(childIndex, 1);
            parent.subTasks = parent.subtaskArray.length;
            return true;
        }

        if (childIndex === -1) {
            if (operation !== "added") return false;
            parent.subtaskArray.push(task);
        } else {
            parent.subtaskArray[childIndex] = {
                ...parent.subtaskArray[childIndex],
                ...task,
            };
        }
        parent.subTasks = Math.max(Number(parent.subTasks) || 0, parent.subtaskArray.length);
        return true;
    }

    const taskIndex = tasks.findIndex((item) => item?._id === task._id);
    if (taskIndex === -1) return false;

    if (operation === "removed") {
        tasks.splice(taskIndex, 1);
    } else {
        tasks[taskIndex] = { ...tasks[taskIndex], ...task };
    }
    return true;
}

module.exports = {
    syncExistingTask,
};
